<template>
<div>
     <button class="d-none" @click="openModal()" id="openQuoteModal">open</button>

      
        <div class="modal fade" id="openQuotesModal" tabindex="-1" aria-labelledby="openQuotesModal" aria-hidden="true">
               <div class="modal-dialog modal-xl">
                      <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Versionnement </h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <i class="fal fa-times"></i>
                                </button>
                            </div>
                            <div class="modal-body">
                                 <div class="row">
                                    <div class="col-sm-12">
                                        <label class="required">Ajouter un devis aux versions du devis actuel</label>
                                        <div class="input-group mb-3">
                                            <input placeholder="Rechercher un devis du même client (numéro ou désignation)…" class="form-control" id="quoteSearchInput" type="text" v-model="quote">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary"  @click="resetField()" type="button" id="button-addon2" title="Effacer la recherche"><i class="far fa-times"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12" v-if="loading">
                                        <p class="ix-text-secondary text-center mb-0">Chargement des versions…</p>
                                    </div>
                                    <div class="col-sm-12" v-if="!loading && quotes.length == 0">
                                        <p class="ix-text-secondary text-center mb-0">Ce devis n'a pas encore d'autre version. Recherchez un devis ci-dessus pour l'ajouter.</p>
                                    </div>
                                    <div class="col-sm-12"  v-if="quotes && quotes.length > 0 && !loading">
                                        <h5>Liste des autres versions</h5>
                                        <div class="ix-table-box">
                                            <table class="ix-table ix-table-sm"> 
                                                <thead>
                                                    <tr>
                                                        <th>Numéro</th>
                                                        <th>Désignation</th>
                                                        <th>Affaire</th>
                                                        <th class="text-right">Total HT</th>
                                                        <th class="text-right">Total TTC</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(quote, index) in quotes" :key="index">
                                                        <td>
                                                            <a :href="quote.id" target="_blank">
                                                                {{quote.number}}
                                                            </a>
                                                            <span class="ix-badge blue ml-1" v-if="!quote.uniq_key" title="Sera ajouté aux versions à l'enregistrement">À ajouter</span>
                                                        </td>
                                                        <td>{{quote.designation}}</td>
                                                        <td>
                                                            {{quote.deal ? quote.deal.number + (quote.deal.name ? " - " + quote.deal.name : '') : ''}}
                                                        </td>
                                                         <td class="text-right"> 
                                                            {{ currency(totalHtWithOptions(quote))}}
                                                        </td>
                                                        <td class="text-right"> 
                                                            {{ currency(totalTtcWithOptions(quote))}}
                                                            <small class="d-block ix-text-secondary" v-if="parseFloat(quote.total_optional_ttc) > 0">dont {{ currency(quote.total_optional_ttc) }} d'options</small>
                                                        </td>
                                                        <th class="text-right">
                                                            <span class="btn btn-sm transparent" @click="removeQuote(quote)" :title="quote.uniq_key ? 'Retirer des versions' : 'Ne pas ajouter'"><i class="far fa-unlink" v-if="quote.uniq_key"></i><i class="far fa-times" v-else></i></span>
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                              <div class="modal-footer justify-content-between">
                                <span class="ix-text-secondary">
                                    <template v-if="pendingCount > 0">{{ pendingCount }} devis à ajouter aux versions</template>
                                </span>
                                <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loading" @click="syncVariant()">
                                    Ajouter aux versions
                                </button>
                              </div>
                      </div>
               </div>

        </div>
</div>
    
</template>
<script>
import $ from "jquery";
import VueSwal from 'vue-swal'


export default {
    name: 'QuoteVersioning',
    props: ['syncVariantUrl', 'variantUrl' , 'unsyncVariantUrl', 'quoteUrl', 'quoteId', 'companyId'],
     data(){
        return {
            quote: null,
            quotes : [],
            loading: false,
            msg: {
                type : null,
                txt : null,
            },
        }
    },
    computed: {
        /** Les devis ajoutés dans la fenêtre, pas encore enregistrés comme versions. */
        pendingCount() {
            return this.quotes.filter(quote => !quote.uniq_key).length;
        },
    },
    methods: {
        /** Le total TTC d'une version, options comprises. */
        totalTtcWithOptions(quote) {
            return (parseFloat(quote.total_ttc) || 0) + (parseFloat(quote.total_optional_ttc) || 0);
        },
        /** Le total HT d'une version, options comprises, après remise globale (comme le total des options). */
        totalHtWithOptions(quote) {
            return (parseFloat(quote.total_after_discount) || 0) + (parseFloat(quote.total_optional_ht) || 0);
        },
        async openModal(){
            $('#openQuotesModal').modal()
            await this.getData();
        },
        resetField(){
            this.quote = null;
            $('#quoteSearchInput').val("");
        },
        getCurrentSelectedQuotesId(){
              return this.quotes.map(quote => quote.id);
        },
        addRow: function (quote){
            if (quote && quote.id && this.getCurrentSelectedQuotesId().includes(quote.id) == false) {
                this.quotes.push(quote);
            }
        },
        removeQuote: function(selectedQuote){
            const existingIndex = this.quotes.findIndex(quote => quote.id === selectedQuote.id);
            if(existingIndex !== -1){
                // Cas ou c'est un variant, maj uniq_key en bdd + supp front
                if(selectedQuote.uniq_key != null){
                     this.$swal({
                        title : "Retirer ce devis des versions ?",
                        text : "Le devis " + selectedQuote.number + " ne fera plus partie des versions de ce devis. Il n'est pas supprimé.",
                        icon : "warning",
                        dangerMode : true,
                        buttons : ["Annuler" , "Retirer"]
                    }).then((willDo) => {
                        if(willDo){
                            fetch(this.unsyncVariantUrl, {
                                ...{
                                    method: 'DELETE'
                                },
                                ...this.getHttpJsonRequestHeaders(),
                                ...{
                                body :JSON.stringify({
                                    quote_id : selectedQuote.id,
                                })
                            }
                            }).then(async (response) => {
                                if (response.ok) {
                                    this.getData();
                                    window.location.reload();
                                }
                            }).catch(error => {
                                console.log(error);
                            })
                        }
                    });
                }
                else {
                  // Cas ou il n'est pas dans la liste des variants, juste une maj en front
                   this.quotes.splice(existingIndex, 1);
                }
            } 
        
        },
        async getData(){
            this.loading = true;

            fetch(this.variantUrl + '?quote_id=' + this.quoteId, {
                  ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                if (response.status == 200) {
                    response.json().then((data) => {
                        if (data.quotes) {
                            this.quotes = data.quotes;
                            this.loading = false;
                        }
                    })
                }
            }).catch((error) => {
                console.log(error);
                this.loading = false;
            })
        },
        async syncVariant(){
            this.loading = true;

            fetch(this.syncVariantUrl,{
                 ...{
                        method : "PUT"
                },
                 ...this.getHttpJsonRequestHeaders(),
                 ...{
                        body :JSON.stringify({
                            quote_id : this.quoteId,
                            quote_ids : this.quotes.filter(quote => !quote.uniq_key).map(quote => quote.id)
                        })
                    }
            }).then((response) => {
                this.loading = false;
                 if (response.ok) {
                    this.resetField();
                    this.getData();
                    window.location.reload();
                 }
            }).catch((error) => {
                this.loading = false;
                console.log(error);
            });
        },
        checkForm: function(){
            return this.quotes.filter(quote => !quote.uniq_key).length > 0;
        }
    },
     async mounted() {

         $("#quoteSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.quoteUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term,  '!id': this.getCurrentSelectedQuotesId().join(';') + ';' + this.quoteId , 'company_id' : this.companyId},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {

                        var designation = item.designation ? ' - ' + item.designation : '';
                       
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.number} ${designation}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                search: (e, item) => {
                    if ($(e.target).val() == '' || $(e.target).val() == null) {
                        this.resetField();
                    }
                },
                change: (e, item) => {
                    if(!item.item){   
                       this.resetField();
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)
                        this.resetField();
                    }
                },
            }).focus(() => {
                $("#quoteSearchInput").autocomplete("search", '');
        })
    }
}
</script>